import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
import type { ScclImportBatchRowResult } from '../types';

function ok(status: string) {
  return status === 'Valid' || status === 'Imported';
}

export function SecurityCommandControlLogImportRowsPreviewTable({ rows }: { rows: ScclImportBatchRowResult[] }) {
  return (
    <div className="max-h-[min(24rem,55vh)] overflow-auto rounded border">
      <table className="w-full text-left text-xs">
        <thead className="sticky top-0 bg-gray-100">
          <tr>
            <th className="px-2 py-1.5">Row</th>
            <th className="px-2 py-1.5">Status</th>
            <th className="px-2 py-1.5">Incident No</th>
            <th className="px-2 py-1.5">Time</th>
            <th className="px-2 py-1.5">Location</th>
            <th className="px-2 py-1.5">Message</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t">
              <td className="px-2 py-1">{r.excelRowNumber}</td>
              <td className="px-2 py-1">
                {ok(r.status) ? (
                  <span className="inline-flex items-center gap-1 text-green-700">
                    <CheckCircle className="h-3 w-3" /> {r.status}
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-red-700">
                    <AlertCircle className="h-3 w-3" /> {r.status}
                  </span>
                )}
              </td>
              <td className="px-2 py-1">{r.incidentNoRaw ?? '—'}</td>
              <td className="px-2 py-1 text-gray-800">{r.incidentTimeRaw ?? '—'}</td>
              <td className="px-2 py-1 text-gray-800">{r.locationRaw ?? '—'}</td>
              <td className="px-2 py-1 text-gray-600">{r.errorMessage ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

